<div class="sidebar-body">
  <div class="search-input">
    <input
      autocomplete="off"
      name="searchmenu"
      placeholder="{{ 'search' | translate }}"
      [autofocus]="true"
      [(ngModel)]="searchText"
    />
    &nbsp;
    <div class="search"><i class="fal fa-search"></i></div>
  </div>
  <div class="button-group">
    <a class="btn btn-sm btn-link" (click)="checkAll()">{{
      "check_all" | translate
    }}</a>
    <a class="btn btn-sm btn-link" (click)="unCheckAll()">{{
      "uncheck_all" | translate
    }}</a>
  </div>
  <div class="column-picker">
    <div *ngFor="let column of columns | searchFilter : searchText : 'label'">
      <ng-container *ngIf="column.children; else elseTemplate">
        <div class="column-with-child">
          <i
            class="fal"
            [ngClass]="
              haveChild[column.label] ? 'fa-angle-down' : 'fa-angle-right'
            "
          ></i>
          <label
            class="column-label"
            id="toggleCheckboxLabel"
            (click)="toggle(column)"
            >{{ column.label | translate }}</label
          >
          <p-checkbox
            *ngFor="
              let childColumn of column.children
                | searchFilter : searchText : 'label'
            "
            name="column_picker"
            binary="true"
            styleClass="kl-checkbox"
            class="hidden-column"
            [ngClass]="
              column.label + '_' + childColumn.label + ' ' + childColumn.class
            "
            [value]="childColumn.value"
            [(ngModel)]="childColumn.value"
            (onChange)="changePicker(childColumn, $event)"
            [label]="childColumn.label | translate"
          >
          </p-checkbox>
        </div>
      </ng-container>
      <ng-template #elseTemplate>
        <p-checkbox
          name="column_picker"
          [value]="column.value"
          [(ngModel)]="column.value"
          (onChange)="changePicker(column, $event)"
          binary="true"
          [label]="column.label | translate"
          styleClass="kl-checkbox"
        >
        </p-checkbox>
      </ng-template>
    </div>
  </div>
</div>
